var React = require('react');

function InfoBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"ic_error_outline_24px","fill":"#66a9f4","d":"M8.75,11.75h1.5v1.5H8.75Zm0-6h1.5v4.5H8.75ZM9.492,2A7.5,7.5,0,1,0,17,9.5,7.5,7.5,0,0,0,9.492,2ZM9.5,15.5a6,6,0,1,1,6-6A6,6,0,0,1,9.5,15.5Z","transform":"translate(-2 -2)"}));
}

InfoBlue.defaultProps = {"viewBox":"0 0 15 15"};

module.exports = InfoBlue;

InfoBlue.default = InfoBlue;
